import React from "react";
import { Loader2, Search } from "lucide-react";

export type SearchableDropdownConfig = {
  searchPlaceholder: string;
  onSearch: (value: string) => void;
  isLoading?: boolean;
  isLoadingMore?: boolean;
  hasMore?: boolean;
  onLoadMore?: () => void;
  optionCount?: number;
};

export function buildSearchableDropdownRender(
  config: SearchableDropdownConfig,
): (menu: React.ReactElement) => React.ReactElement {
  const {
    searchPlaceholder,
    onSearch,
    isLoading = false,
    isLoadingMore = false,
    hasMore = false,
    onLoadMore,
    optionCount = 0,
  } = config;

  return (menu: React.ReactElement) => (
    <div>
      <div className="p-2 border-b border-gray-200">
        <div className="relative">
          <Search className="absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder={searchPlaceholder}
            onChange={(e) => onSearch(e.target.value)}
            className="w-full rounded-md border border-gray-300 py-2 pl-8 pr-3 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
          />
          {isLoading && (
            <Loader2 className="absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 animate-spin text-gray-400" />
          )}
        </div>
      </div>

      <div
        className="max-h-40 overflow-y-auto"
        onScroll={(e) => {
          if (!onLoadMore) return;
          const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
          if (
            scrollHeight - scrollTop <= clientHeight + 50 &&
            hasMore &&
            !isLoading &&
            !isLoadingMore
          ) {
            onLoadMore();
          }
        }}
      >
        {menu}

        {isLoadingMore && hasMore && (
          <div className="flex items-center justify-center border-t px-3 py-2">
            <Loader2 className="mr-2 h-4 w-4 animate-spin text-gray-400" />
            <span className="text-sm text-gray-500">Loading more...</span>
          </div>
        )}

        {!hasMore && optionCount > 0 && (
          <div className="border-t px-3 py-2 text-center text-xs text-gray-400">
            No more options
          </div>
        )}
      </div>
    </div>
  );
}
